import { render, staticRenderFns } from "./the-sidebar-link.vue?vue&type=template&id=53bc7224"
import script from "./the-sidebar-link.vue?vue&type=script&lang=js"
export * from "./the-sidebar-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../CrossD.Portal.Vue/ClientApp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports